import { COLORS } from 'helpers/globals'
import { DOWNTILT_PREVIEW_DIMENSIONS } from 'helpers/globals'

export default {
  container: {
    bottom: 20,
    width: 20,
    position: 'absolute',
    borderBottom: `1px solid ${COLORS.quaternary}`,
    transition: 'all 200ms linear 0s'
  },
  cameraIcon: {
    position: 'absolute',
    left: 13,
    width: DOWNTILT_PREVIEW_DIMENSIONS.cameraIconHeight,
    height: 'auto',
    top: 1,
    transformOrigin: 'center top'
  },
  heightDisplay: {
    position: 'absolute',
    lineHeight: '1.8rem',
    padding: '.2rem 0',
    width: '100%',
    background: 'white'
  },
  dividerLineHeight: {
    display: 'inline-block',
    position: 'absolute',
    left: 7,
    height: '100%',
    borderLeft: `1px dashed ${COLORS.quaternary}`,
    zIndex: -1
  }
}



// WEBPACK FOOTER //
// ./src/components/BlindSpotPanelContainer/DowntiltDisplayContainer/CameraHeightLabel/style.js